import React, {useState } from 'react';
import { Routes ,Route, useNavigate } from 'react-router-dom';
import Register from '../user/register/register';
import AccountPublic from '../user/account-public';
import MaterialList from '../materials/material-list';
import MaterialDetails from '../materials/material-detail';
import MaterialBuyAdd from '../materials/mat-buy-add';
import MaterialNew from '../materials/material-new';
import ShoppingList from '../materials/shopping-list';
// import ReportSell from '../materials/report-sell';
import MaterialGroup from '../materials/material-groups';
import SendInbox from '../inbox/msg-send';
import InboxMessage from '../inbox/my-inbox';
import Login from '../user/login-sys';
import RequestBuy from '../materials/request-buy';
import SiteSetting from './my-company';
import MaterialMakeLink from '../materials/material-link';
import Logout from '../user/logout';
import ReportReqBuy from './dialog/report/report-req-buy';
import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import AnswerForm from './dialog/answer-form';
import ReportReqFinal from './report/report-req-work';

// import { getAllDatas } from '../../services/material-services';



function Main({dataMain}) {
    const {loginAgain } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
      
        if(loginAgain){
          navigate('/login')
        }
    }, [loginAgain, navigate])

  return (
    <div className="main">
      <Routes>
        <Route exact path="/" element={<MaterialList dataMain={dataMain} />} />
        <Route exact path="/:type" element={<MaterialList dataMain={dataMain} />} />
        <Route path="/:main/:type/:id" element={<MaterialDetails />} />
        <Route path="/:main/:id" element={<MaterialDetails />} />
        <Route path="/mat-buy-add" element={<MaterialBuyAdd />} />
        <Route path="/mat-new" element={<MaterialNew />} />
        <Route path="/shopping" element={<ShoppingList />} />
        {/* <Route path="/report" element={<ReportSell />} /> */}
        <Route path="/request-buy" element={<ReportReqBuy />} />
        <Route path="/mat-groups" element={<MaterialGroup />} />
        <Route path="/send-inbox" element={<SendInbox />} />
        <Route path="/my-inbox" element={<InboxMessage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/req-free" element={<RequestBuy />} />
        <Route path="/mysetting" element={<SiteSetting />} />
        <Route path="/mat-link" element={<MaterialMakeLink />} />
        <Route path="*">{Error}</Route>
        <Route path="/register" element={<Register />} />
        <Route path="/account" element={<AccountPublic />} /> 
        <Route path="/logout" element={<Logout />} /> 
        <Route path="/answer-buy" element={<AnswerForm />} /> 
        <Route path="/request-final" element={<ReportReqFinal />} /> 

      </Routes>
    </div>
  )
}

export default Main
